import { render } from "./Project-item.vue?vue&type=template&id=2e6d6ca9&scoped=true"
import script from "./Project-item.vue?vue&type=script&lang=js"
export * from "./Project-item.vue?vue&type=script&lang=js"

import "./Project-item.vue?vue&type=style&index=0&id=2e6d6ca9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e6d6ca9"

export default script